module.exports = __webpack_public_path__ + "img/login_bg.138665db.png";